var path = 'api/Portal/AccessRequest/'

function getViews (http) {
    return http.get(path + 'GetViews')
}

function insertRequest (http, roleRequest) {
    return http.post(path + 'InsertRequest?roleRequest=' + roleRequest)
}

function denyRequest (http, accessRequestId) {
    return http.post(path + 'DenyRequest?accessRequestId=' + accessRequestId)
}

function getRequestsForCurrentUser (http) {
    return http.post(path + 'GetRequestsForCurrentUser')
}

export default {
    getViews: getViews,
    insertRequest: insertRequest,
    denyRequest: denyRequest,
    getRequestsForCurrentUser: getRequestsForCurrentUser
}
